import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHangjongeren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.052 8.08c1.034-.889 2.303-1.334 3.541-.992l-.266.964c-.823-.228-1.758.042-2.624.786-.863.742-1.613 1.925-2.01 3.393l-.966-.262c.443-1.632 1.288-3 2.325-3.89"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M12.67 19.17A5.33 5.33 0 0 1 18 24.5v8.89H7.33V24.5a5.34 5.34 0 0 1 5.34-5.33"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M12.67 19.17a5.33 5.33 0 1 0 0-10.66 5.33 5.33 0 0 0 0 10.66"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M18 13.84a5.343 5.343 0 0 0-5.335-5.571A5.34 5.34 0 0 0 7.33 13.84"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M27.33 19.17a5.33 5.33 0 1 0 0-10.66 5.33 5.33 0 0 0 0 10.66"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M32.46 15.25a5.333 5.333 0 1 0-10.26-2.91"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M8.54 9.71A5.84 5.84 0 0 1 12.67 8v1a4.84 4.84 0 0 0-4.84 4.84v.5H4v-1h2.851a5.84 5.84 0 0 1 1.69-3.63"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M27.33 19.17A5.33 5.33 0 0 0 22 24.5v8.89h10.67V24.5a5.34 5.34 0 0 0-5.34-5.33"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M32.131 9.752c.439 1.294.474 2.897.031 4.51l-.964-.264c.397-1.447.352-2.844-.014-3.925-.368-1.085-1.035-1.797-1.855-2.02l.262-.965c1.24.336 2.103 1.374 2.54 2.664"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M31.25 14.15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHangjongeren);

export default ForwardRef;
